import { getJustAlphanumericCharacters } from './getJustAlphanumericCharacters.js';

/**
 * Generates the name to be used for localStorage, using the site host and pathname to make state unique to each unique host and post
 * @returns {string} the name to be used for localStorage
 */
export function generateAppStateLocalstorageName() {
  const host = getJustAlphanumericCharacters(window.location.host);
  const path = getJustAlphanumericCharacters(window.location.pathname);

  return `geaLsAppState_${host}_${path}`;
}
